<form [formGroup]="changePasswordForm" (ngSubmit)="onSubmitChangePasswordForm()" class="wrapper-change-password-page">
  <div class="tl-d-flex tl-flex-column">
    <span class="title-settings-page">
      {{'CHANGE_PASSWORD.change_password' | translate}}
    </span>
    <span class="subtitle-settings-page">
      {{'CHANGE_PASSWORD.create_a_new_password_for_your_account' | translate}}
    </span>
  </div>
  <div class="small-height-resolution">
    <div class="wrapper-input" [ngClass]="{'error': changePasswordForm.controls['password'] | formControlErrorMessages: null: formTriedToSubmit}">
      <span class="label-input">
        {{'CHANGE_PASSWORD.current_password' | translate}}
      </span>
      <div class="custom-input">
        <input
          [type]="isCurrentPasswordShow ? 'text' : 'password'"
          formControlName="password"
          [placeholder]="'CHANGE_PASSWORD.enter_current_password' | translate">
        <img *ngIf="!isCurrentPasswordShow" (click)="isCurrentPasswordShow = true" class="icon-input" src="../assets/icons/outline/icon-outline-eye.svg" alt="">
        <img *ngIf="isCurrentPasswordShow" (click)="isCurrentPasswordShow = false" class="icon-input" src="../assets/icons/outline/icon-outline-eye-with-slash.svg" alt="">
      </div>
      <div *ngIf="changePasswordForm.controls['password'] | formControlErrorMessages: null: formTriedToSubmit" class="wrapper-error-message">
        <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
        <span>{{changePasswordForm.controls['password'] | formControlErrorMessages: null: formTriedToSubmit}}</span>
      </div>
    </div>
    <div class="wrapper-input" [ngClass]="{'error': changePasswordForm.controls['new_password'] | formControlErrorMessages: null: formTriedToSubmit}">
      <span class="label-input"> {{'CHANGE_PASSWORD.new_password' | translate}}</span>
      <div class="custom-input">
        <input
          [type]="isNewPasswordShow ? 'text' : 'password'"
          formControlName="new_password"
          [placeholder]="'CHANGE_PASSWORD.enter_new_password' | translate">
        <img *ngIf="!isNewPasswordShow" (click)="isNewPasswordShow = true" class="icon-input" src="../assets/icons/outline/icon-outline-eye.svg" alt="">
        <img *ngIf="isNewPasswordShow" (click)="isNewPasswordShow = false" class="icon-input" src="../assets/icons/outline/icon-outline-eye-with-slash.svg" alt="">
      </div>
      <div *ngIf="(changePasswordForm.controls['new_password'] | formControlErrorMessages: null: formTriedToSubmit) === 'Minimum of 8 characters'" class="error-message">
        <span>{{'ERROR.your_password_needs_to_have' | translate}}</span>
      </div>
      <div *ngIf="changePasswordForm.controls['new_password'] | formControlErrorMessages: null: formTriedToSubmit" class="wrapper-error-message">
        <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
        <span>{{changePasswordForm.controls['new_password'] | formControlErrorMessages: null: formTriedToSubmit}}</span>
      </div>
      <div *ngIf="changePasswordForm.controls['new_password'].valid" class="error-message purple" >
        <span>{{'ERROR.your_password_needs_to_have' | translate}}</span>
      </div>
      <div *ngIf="changePasswordForm.controls['new_password'].valid" class="wrapper-error-message purple">
        <img src="../assets/icons/outline/icon-check-circle.svg" alt="">
        <span>{{'ERROR.minimum_of_8_characters' | translate}}</span>
      </div>
    </div>
    <div class="wrapper-input" [ngClass]="{'error': changePasswordForm.controls['password_confirmation'] | formControlErrorMessages: null: formTriedToSubmit}">
      <span class="label-input">{{'CHANGE_PASSWORD.confirm_new_password' | translate}}</span>
      <div class="custom-input">
        <input
          [type]="isConfirmPasswordShow ? 'text' : 'password'"
          formControlName="password_confirmation"
          [placeholder]="'CHANGE_PASSWORD.confirm_new_password' | translate">
        <img *ngIf="!isConfirmPasswordShow" (click)="isConfirmPasswordShow = true" class="icon-input" src="../assets/icons/outline/icon-outline-eye.svg" alt="">
        <img *ngIf="isConfirmPasswordShow" (click)="isConfirmPasswordShow = false" class="icon-input" src="../assets/icons/outline/icon-outline-eye-with-slash.svg" alt="">
      </div>
      <div *ngIf="changePasswordForm.controls['password_confirmation'] | formControlErrorMessages: null: formTriedToSubmit" class="wrapper-error-message">
        <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
        <span>{{changePasswordForm.controls['password_confirmation'] | formControlErrorMessages: null: formTriedToSubmit}}</span>
      </div>
    </div>
    <div class="wrapper-submit-settings">
      <button type="submit" class="custom-btn custom-btn--primary">
        <span>{{'CHANGE_PASSWORD.change_password' | translate}}</span>
        <tl-spinner *ngIf="isSpinnerActive"></tl-spinner>
      </button>
    </div>
  </div>
</form>
